import SunAccent from "@/components/feature/SunAccent";
import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

export default function TripCta() {
  return (
    <section className="sun-glaze bg-background-50 pb-20 md:pb-28">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <div className="bg-primary-900 rounded-lg p-8 md:p-14 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <div className="mb-4">
                <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" />
              </div>
              <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-300">
                Ready When You Are
              </span>
              <h2 className="font-heading text-3xl md:text-4xl leading-tight text-background-50 font-semibold mt-4">
                Let's Turn Your Plan Into a Real Journey
              </h2>
              <p className="mt-5 text-base text-background-200 leading-relaxed max-w-2xl">
                Share the itinerary you've built and our team will confirm dates, timings and
                logistics — then welcome you to the delta.
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-col gap-3">
              <Link
                to="/contact#contact-form"
                className="inline-flex items-center justify-center gap-2 bg-accent-500 text-background-50 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Talk to Our Team
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/experiences"
                className="inline-flex items-center justify-center gap-2 bg-background-50/10 backdrop-blur-sm border border-background-50/40 text-background-50 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                Browse Experiences
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}